<template>
  <li
    class="nav-item px-2 text"
    style="text-align: left"
    >
    <!-- :class="{ 'menu-open': seccion_actual == 'superadministrador' }" -->
    <!-- Titulo sección -->
    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-users-cog"></i>
      <p>SuperAdministrador<i class="fas fa-angle-left right"></i></p>
    </a>

    <ul class="nav nav-treeview">
      <!-- Filiales -->
      <li class="nav-item" v-if="showFiliales">
        <router-link class="nav-link" to="/superadministrador/filiales">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Filiales</p>
        </router-link>
      </li>

      <!-- Mantenedor Regional -->
      <li class="nav-item" v-if="showMantenedorRegional">
        <router-link
          class="nav-link"
          to="/superadministrador/mantenedor_regional"
        >
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Mantenedor Regional</p>
        </router-link>
      </li>

      <!-- Módulos -->
      <li class="nav-item" v-if="showModulos">
        <router-link class="nav-link" to="/superadministrador/modulos">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Módulos</p>
        </router-link>
      </li>

      <!-- Roles -->
      <li class="nav-item" v-if="showRoles">
        <router-link class="nav-link" to="/superadministrador/roles">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Roles</p>
        </router-link>
      </li>

      <!-- Secciones -->
      <li class="nav-item" v-if="showSecciones">
        <router-link class="nav-link" to="/superadministrador/secciones">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Secciones</p>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:25
 */
// Vuex
import { mapState } from "vuex";
import { validSuperAdmin } from '../../mixins'

export default {
  data() {
    return {
      current_url: "",
      showSuperAdmin: false,
      showModulos: false,
      showFiliales: false,
      showRoles: false,
      showMantenedorRegional: false,
      showSecciones: false,
    };
  },
  computed: {
    ...mapState(["url_actual", "seccion_actual"]),
    ...mapState("seccionesSuperAdministrador", [
      "isFiliales",
      "isMantenedorRegional",
      "isModulos",
      "isRoles",
      "isSecciones",
    ]),
  },
  created(){
    const superAdminRoleStructure = validSuperAdmin(JSON.parse(localStorage.getItem('roleStructure')));
    this.showModulos = superAdminRoleStructure.showModulos;
    this.showFiliales = superAdminRoleStructure.showFiliales;
    this.showRoles = superAdminRoleStructure.showRoles;
    this.showMantenedorRegional = superAdminRoleStructure.showMantenedorRegional;
    this.showSecciones = superAdminRoleStructure.showSecciones;
    
  }
};
</script>
